import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import '../../../src/styles/Login.css';
import { FaChevronUp } from 'react-icons/fa';
import { Accordion } from 'react-bootstrap';
import DocumentMeta from 'react-document-meta';
import { Card } from 'react-bootstrap';

export class GetPassword extends Component {
    displayName = GetPassword.name
    render() {
        const meta = {
            title: "Kluwer Law Online - Get password"
        }
        return (
            <DocumentMeta {...meta}>
            <div className="col-12">
                <div className="White">
                </div>
                <div className="White">
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="col-lg-12 BGGrey Loginhomepadding LoginHeight logintop">
                            <p className="LoginText color franziskafont" style={{ marginBottom: '2%'}}> Password reminder successful! </p>
                            <p className="LoginText" style={{ marginBottom: '2%' }}>Please check your inbox (or spam folder) to access
                            your password and then login below.</p>
                            <p className="LoginText LoginSetright"><input className="form-control BookBody" type="text" placeholder="User name" /></p>
                            <p className="LoginText LoginSetright"><input className="form-control BookBody" type="text" placeholder="Password" /></p>
                            <p className="LoginText"><a href="/ForgotPassword" className="LinkClass">Forgot password</a></p>
                            <p className="LoginText"><a href="/LoginHome" className="btn btn-info next" role="button">Login</a></p>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="col-lg-12 BGGrey divleft LoginHeight logintop">
                            <p className="LoginText franziskafont"> Login via your institution</p>
                            <br></br><br></br>
                            <div className="flex-lg-row LoginText LoginSetright">
                                <div className="LoginDrpdown">
                                    <Accordion defaultActiveKey="0">
                                        <Card className="cardBorderZero">
                                            <Card.Header className="panel-heading">
                                                <Accordion.Toggle as={Card.Header} eventKey="0" className="cardmargin">
                                                    <h5 className="panel-title">Choose institution</h5>
                                                    <span className="pull-right clickable"><FaChevronUp /></span>
                                                </Accordion.Toggle>
                                            </Card.Header>
                                        </Card>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="col-lg-12 BGGrey LoginHeight logintop loginsetwdth">
                            <p className="LoginText franziskafont"> Login via OpenAthens<br></br><br></br>
                                <a href="/" className="LinkClass">Go to OpenAthens</a></p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <br/>
                    <p className="logina">Not yet a customer? <a href="https://wolterskluwer.com/" target="_blank" className="LinkClass"> Find out about Kluwer Law Online </a> </p>
                </div >
                <div className="White">
                </div>
                <div className="White">
                </div>
            </div >
            </DocumentMeta>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Login/GetPassword.jsx